export { default as ArrowRightTriangleSolidIcon } from './ArrowRightTriangleSolidIcon';
